import { render, staticRenderFns } from "./TextAlignRight.vue?vue&type=template&id=0b8a3862&scoped=true&"
import script from "./TextAlignRight.vue?vue&type=script&lang=js&"
export * from "./TextAlignRight.vue?vue&type=script&lang=js&"
import style0 from "./TextAlignRight.vue?vue&type=style&index=0&id=0b8a3862&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8a3862",
  null
  
)

export default component.exports